import React from "react";
import { Row, Col } from "reactstrap";
import { Link as ScrollLink } from 'react-scroll';

import coverImage from "assets/img/partner_2.png";

const PartnerWith = () => {
  return (
    <>
      <h2 className="text-center title" style={{ color: "white", marginTop: '20px', marginBottom: '20px', fontWeight: 'bolder'}}>Partner With MagLev Aero</h2>
      <Row>
        <Col xs={12} lg={4} md={12} className="text-center text-lg-left d-flex align-items-center mb-4 mb-md-0 order-md-1 order-2">
          <p style={{ color: "white", fontSize: '1.25em', marginBottom: '20px'}}>
            Join forces with MagLev Aero for a groundbreaking partnership in advanced propulsion technology. 
            Elevate your transportation solutions with our cutting-edge maglev technology, redefining efficiency and sustainability. 
            Whether it's revolutionizing cargo transport, enhancing drone capabilities, or transforming Urban Air Mobility, together we can shape a future of innovation and sustainability.
            <br/><br/>
            <ScrollLink
              className ='nav-link'
              to="Contact" // Replace with the name of your contact section Element
              href="#"
              spy={true}
              smooth={true}
              duration={500} // Duration of the scroll animation
              style={{color: "white", padding: 0}}
            >
              <u style={{color:'#6EBAD7'}}>Contact us</u> below for more information.
            </ScrollLink>
          </p>
        </Col>
        <Col xs={12} lg={8} md={12} className="text-center d-flex align-items-center mb-4 mb-md-0 order-md-1 order-1">
          <img src={coverImage} alt="hyperdeltas in the city render" style={{width:'100%'}}/>
        </Col>
      </Row>
    </>
  );
};

export default PartnerWith;
